import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Map } from 'immutable';
import { login, codeLogin, codeReLogin } from '../../actions/session';
import LoginForm from './LoginForm';
import AuthForm from './AuthForm';
import {
  LOGIN_CODE_REQUIRED,
  REQUESTING_LOGIN_CODE,
  REQUESTING_LOGIN,
} from '../../constants/sessionStateTypes';

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  onLoginSubmit: (username, password) => dispatch(login(username, password)),
  onCodeSubmit: code => dispatch(codeLogin(code)),
  dispatch: func => dispatch(func),
  resetLogin: () => dispatch(codeReLogin()),
});

const Login = (props) => {
  const sessionStateMessage = props.session.get('sessionStateMessage') && props.session.get('sessionStateMessage').message;
  const sessionState = props.session.get('sessionState');

  const loginForm = sessionState === LOGIN_CODE_REQUIRED || sessionState === REQUESTING_LOGIN_CODE ?
    (<AuthForm
      onSubmit={props.onCodeSubmit}
      sessionStateMessage={sessionStateMessage || ''}
      isLoading={sessionState === REQUESTING_LOGIN_CODE}
      loginCodeState={props.session.get('loginCodeState')}
      dispatch={props.dispatch}
      resetLogin={props.resetLogin}
    />) :
    (<LoginForm
      onSubmit={props.onLoginSubmit}
      sessionStateMessage={sessionStateMessage || ''}
      isLoading={sessionState === REQUESTING_LOGIN}
    />);

  return (
    <div className="login">
      {}
      {loginForm}
      <div className="login-copy">
        <h3 className="login-copy__header">Digital Media Warehouse</h3>
        <p className="login-copy__text">
          For managing all types of digital content including images, video, audio and documents.
          We combine a full digital asset management system with strong workflow and content
          distribution functions to provide a platform
          that can solve your digital media management requirements.
        </p>
      </div>
    </div>
  );
};

Login.propTypes = {
  onLoginSubmit: PropTypes.func,
  onCodeSubmit: PropTypes.func,
  session: PropTypes.instanceOf(Map),
  dispatch: PropTypes.func,
  resetLogin: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Login));
